var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",style:('background: rgba(255, 255, 255, ' + _vm.opacity + ');')},[(_vm.showTitle)?_c('div',{staticClass:"head"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }